import React from "react";
import {isInArray} from "../../../../Utilities/Types/arrayUtilities";
import {HtmlDisplay} from "../../../Display";
import {buttonIconType, buttonIconTypeList} from "./buttonIconConstants";

interface ButtonIconProps {
	disabled?: boolean;
	inputDescription: string;
	iconType?: string;
	isInputAction?: boolean;
	id?: string;
	name?: string;
	onClick?: (e?: React.MouseEvent<HTMLButtonElement>) => void;
	children?: React.ReactNode;
}

const ButtonIcon: React.FC<ButtonIconProps> = ({disabled, inputDescription, iconType, isInputAction, id, onClick, children}) => {

	if (!iconType || !isInArray(buttonIconTypeList, iconType)) return <> </>;

	const actionClass = isInputAction ? "buttonIcon--inputAction" : "";
	const disabledClass = disabled ? "is-disabled" : "";

	return (
		<span className={`buttonIcon ${iconType} ${actionClass} ${disabledClass}`}>
            <button
				id={id}
	            className={`buttonIcon__button`}
	            disabled={disabled}
	            onClick={onClick}
				data-testid={id}
				type={`button`}
            >
				<HtmlDisplay html={inputDescription} className={`show-for-sr`} isInline />
            </button>
            <span aria-hidden={true} className="buttonIcon__flag"/>
			{children}
        </span>
	);
};

export const ButtonIconAdd: React.FC<ButtonIconProps> = (props) => <ButtonIcon {...props} iconType={buttonIconType.ADD}/>;
export const ButtonIconAddOption: React.FC<ButtonIconProps> = (props) => <ButtonIcon {...props} iconType={buttonIconType.ADD_OPTION}/>;
export const ButtonIconApprove: React.FC<ButtonIconProps> = (props) => <ButtonIcon {...props} iconType={buttonIconType.APPROVE}/>;
export const ButtonIconBarcode: React.FC<ButtonIconProps> = (props) => <ButtonIcon {...props} iconType={buttonIconType.BARCODE} />;
export const ButtonIconCancel: React.FC<ButtonIconProps> = (props) => <ButtonIcon {...props} iconType={buttonIconType.CANCEL} />;
export const ButtonIconCertificate: React.FC<ButtonIconProps> = (props) => <ButtonIcon {...props} iconType={buttonIconType.CERTIFICATE}/>;
export const ButtonIconCopyClipboard: React.FC<ButtonIconProps> = (props) => <ButtonIcon {...props} iconType={buttonIconType.COPY_CLIPBOARD}/>;
export const ButtonIconCopyComponent: React.FC<ButtonIconProps> = (props) => <ButtonIcon {...props} iconType={buttonIconType.COPY_COMPONENT}/>;
export const ButtonIconDelete: React.FC<ButtonIconProps> = (props) => <ButtonIcon {...props} iconType={buttonIconType.DELETE}/>;
export const ButtonIconDeleteComponent: React.FC<ButtonIconProps> = (props) => <ButtonIcon {...props} iconType={buttonIconType.DELETE_COMPONENT}/>;
export const ButtonIconDoneEditing: React.FC<ButtonIconProps> = (props) => <ButtonIcon {...props} iconType={buttonIconType.DONE_EDITING}/>;
export const ButtonIconEdit: React.FC<ButtonIconProps> = (props) => <ButtonIcon {...props} iconType={buttonIconType.EDIT}/>;
export const ButtonIconEnrollments: React.FC<ButtonIconProps> = (props) => <ButtonIcon {...props} iconType={buttonIconType.ENROLLMENTS}/>;
export const ButtonIconFollowup: React.FC<ButtonIconProps> = (props) => <ButtonIcon {...props} iconType={buttonIconType.DOWNLOAD_FOLLOWUP}/>;
export const ButtonIconImpersonate: React.FC<ButtonIconProps> = (props) => <ButtonIcon {...props} iconType={buttonIconType.IMPERSONATE}/>;
export const ButtonIconContent: React.FC<ButtonIconProps> = (props) => <ButtonIcon {...props} iconType={buttonIconType.CONTENT}/>;
export const ButtonIconMenu: React.FC<ButtonIconProps> = (props) => <ButtonIcon {...props} iconType={buttonIconType.MENU}/>;
export const ButtonIconModules: React.FC<ButtonIconProps> = (props) => <ButtonIcon {...props} iconType={buttonIconType.MODULES}/>;
export const ButtonIconOrder: React.FC<ButtonIconProps> = (props) => <ButtonIcon {...props} iconType={buttonIconType.ORDER}/>;
export const ButtonIconPackingList: React.FC<ButtonIconProps> = (props) => <ButtonIcon {...props} iconType={buttonIconType.PACKING_LIST}/>;
export const ButtonIconPrint: React.FC<ButtonIconProps> = (props) => <ButtonIcon {...props} iconType={buttonIconType.PRINT}/>;
export const ButtonIconProfile: React.FC<ButtonIconProps> = (props) => <ButtonIcon {...props} iconType={buttonIconType.PROFILE}/>;
export const ButtonIconRemove: React.FC<ButtonIconProps> = (props) => <ButtonIcon {...props} iconType={buttonIconType.REMOVE}/>;
export const ButtonIconRepairDetails: React.FC<ButtonIconProps> = (props) => <ButtonIcon {...props} iconType={buttonIconType.REPAIR_DETAILS}/>;
export const ButtonIconSave: React.FC<ButtonIconProps> = (props) => <ButtonIcon {...props} iconType={buttonIconType.SAVE}/>;
export const ButtonIconSearch: React.FC<ButtonIconProps> = (props) => <ButtonIcon {...props} iconType={buttonIconType.SEARCH}/>;
export const InputClear: React.FC<ButtonIconProps> = (props) => <ButtonIcon {...props} iconType={buttonIconType.CLEAR} isInputAction/>;
export const ButtonIconExit: React.FC<ButtonIconProps> = (props) => <ButtonIcon {...props} iconType={buttonIconType.EXIT} isInputAction/>;
export const ButtonIconHistory: React.FC<ButtonIconProps> = (props) => <ButtonIcon {...props} iconType={buttonIconType.HISTORY} isInputAction/>;
export const ButtonIconView: React.FC<ButtonIconProps> = (props) => <ButtonIcon {...props} iconType={buttonIconType.VIEW}/>;
export const ButtonIconProgress: React.FC<ButtonIconProps> = (props) => <ButtonIcon {...props} iconType={buttonIconType.PROGRESS}/>;
export const ButtonIconUpload: React.FC<ButtonIconProps> = (props) => {
	const {onClick, name} = props;
	const fileName = `${name}_file`;
	const onButtonClick = () => document.getElementById(fileName)!.click();

	return <>
		<ButtonIcon {...props} iconType={buttonIconType.UPLOAD} onClick={onButtonClick}>
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
			<label htmlFor={fileName}>
                <HtmlDisplay html={props.inputDescription} className={`show-for-sr`} isInline />
			</label>
			<input type="file"
				       data-testid={fileName}
				       name={fileName}
				       id={fileName}
				       onChange={onClick as unknown as React.ChangeEventHandler<HTMLInputElement>}
			/>
		</ButtonIcon>
	</>;
};
